import { render } from "./ModalNewsletter.vue?vue&type=template&id=67e5a97d"
import script from "./ModalNewsletter.vue?vue&type=script&lang=js"
export * from "./ModalNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__